import VirtualScroll from 'virtual-scroll'

function ioss() {

    Number.prototype.clamp = function (min, max) {
        return Math.min(Math.max(this, min), max)
    }

    $('.ioss').each(function (index) {
        const $module = $(this)
        const $ssCont = $module.find('.ioss--cont')
        const $ss = $module.find('.ioss--ss')
        const $items = $module.find('.ioss--ssitem')
        const $progressbar = $module.find('.ioss--progress')
        const length = $items.length
        const $a = $module.find('a')

        let canScrollWhole = false
        const scroller = new VirtualScroll({passive: false})

        if (length <= 1) {
            $module.addClass('js-start js-end');
            return
        }

        let isInFlexMode = false
        let isVertical = false

        const $next = $module.find('.ioss--next')
        const $prev = $module.find('.ioss--prev')
        const $nav = $module.find('.ioss--dotnav')

        for (let i = 0; i < length; i++) {
            $nav.append(`<button class="ioss--dotnavitem"></button>`)
        }
        const $navdot = $module.find('.ioss--dotnavitem')

        let sliderContainerSize = 0
        let sliderSize = 0
        let sliderPositionStart = 0
        let sliderPositionEnd = 0
        let canMove = false
        let snaps = []
        let speed = 0.2

        // Prevent dragging on links
        $a.each(function () {
            $(this)[0].setAttribute('draggable', false)
        })

        // Helpers dépendants de l’axe
        function getOffset($el) {
            return isVertical ? $el.offset().top : $el.offset().left
        }

        function getSize($el) {
            return isVertical ? $el.outerHeight(true) : $el.outerWidth(true)
        }

        function getContainerSize() {
            return isVertical ? $ss.outerHeight() : $ss.outerWidth()
        }

        function setTranslate(value) {
            gsap.set($ss, isVertical ? { y: -value } : { x: -value })
        }

        // Resize
        const debounceResize = _.debounce(function () {
            getSizes()
        }, 300)

        function getSizes() {
            canScrollWhole = $module.css('--scroll') === "1" ? true : false

            $module.removeClass('js-candrag')

            isInFlexMode = $ss.css('display') === 'flex' && $ss.css('flex-wrap') !== 'wrap'
            if (!isInFlexMode) {
                $nav.removeClass('js-active')
                $module.addClass('js-start js-end')
                pos.current = pos.eased = pos.easedReal = 0
                canMove = false
                gsap.set($ss, { x: 0, y: 0 })
                return
            }

            const flexDirection = $ss.css('flex-direction') || 'row'
            isVertical = flexDirection.startsWith('column')

            // snaps
            snaps = []
            const ssOffset = getOffset($ssCont)
            $items.each(function () {
                snaps.push(Math.round(getOffset($(this)) + pos.easedReal) - ssOffset)
            })

            // slider size
            sliderContainerSize = getContainerSize()
            sliderSize = 0
            $items.each(function () {
                sliderSize += getSize($(this))
            })

            sliderPositionStart = 0
            sliderPositionEnd = sliderSize - sliderContainerSize

            if (sliderPositionEnd <= 0) {
                sliderPositionEnd = 0
                canMove = false
            } else {
                canMove = true
                $module.addClass('js-candrag')
            }

            if (typeof pos.current !== "number") pos.current = 0
            pos.current = pos.current.clamp(sliderPositionStart, sliderPositionEnd)
            pos.current = utils.closest(pos.current, snaps)

            // Hide useless dots
            let tolerance = 10
            const count = snaps.filter(v => v >= sliderPositionStart - tolerance && v <= sliderPositionEnd + tolerance).length;
            if (count > 1) {
                $nav.addClass('js-active')
                $navdot.addClass('js-hide')
                for (var i = count - 1; i >= 0; i--) {
                    $navdot.eq(i).removeClass('js-hide')
                }
            } else {
                $nav.removeClass('js-active')
            }

            snaps = snaps.filter(v => v <= sliderPositionEnd);
            if (snaps.length === 0 || snaps[snaps.length - 1] < sliderPositionEnd) {
                snaps.push(sliderPositionEnd);
            }

            isStartOrEnd()
            updateNav()
        }

        // Dot nav
        function navdotClick() {
            const $this = $(this)
            const id = $this.index()
            currentId = id
            navigateTo(currentId)
        }
        function updateNav() {
            $navdot.removeClass('js-active')
            $navdot.eq(currentId).addClass('js-active')
        }

        let currentId = 0
        function navigateTo(id) {
            pos.current = snaps[id].clamp(sliderPositionStart, sliderPositionEnd)
            isStartOrEnd()
            updateNav()
        }
        function prev() {
            currentId--
            if (currentId < 0) currentId = 0
            navigateTo(currentId)
        }
        function next() {
            currentId++
            if (currentId >= length) currentId = length - 1
            navigateTo(currentId)
        }

        // RAF
        let pos = { current: 0, eased: 0, easedReal: 0 }
        let forceFirstDraw = true

        function raf() {
            const nextEased = utils.lerp(pos.eased, pos.current, speed * window.deltaRatio)

            if (forceFirstDraw || u.canDraw(nextEased, pos.eased, 3)) {
                pos.easedReal = u.deci(pos.eased, 2)
                setTranslate(pos.easedReal)
            }

            pos.eased = nextEased
            forceFirstDraw = false

            let perone = (pos.easedReal / sliderPositionEnd).clamp(0, 1)
            gsap.set($module, { "--progress": perone })
        }

        function goToClosestSnap() {
            pos.current = utils.closest(pos.current, snaps)
            currentId = snaps.indexOf(pos.current)
            pos.current = pos.current.clamp(sliderPositionStart, sliderPositionEnd)
            isStartOrEnd()
            updateNav()
        }

        function isStartOrEnd() {
            $module.toggleClass('js-start', pos.current <= sliderPositionStart)
            $module.toggleClass('js-end', pos.current >= sliderPositionEnd)
        }

        // Progressbar
        let isDraggingProgressbar = false
        function onProgressbarMouseDown() {
            isDraggingProgressbar = true
            updateProgressbarPosition()
        }
        function onProgressbarMouseMove() {
            if (!isDraggingProgressbar) return
            updateProgressbarPosition()
        }
        function onProgressbarMouseUp(e) {
            if (!isDraggingProgressbar) return
            isDraggingProgressbar = false
            goToClosestSnap()
        }

        function updateProgressbarPosition() {
            const offset = $progressbar.offset().left
            const width = $progressbar.outerWidth()
            const posAxis = isVertical ? mm.posCurrent.y : mm.posCurrent.x
            const ratio = ((posAxis - offset) / width).clamp(0, 1)
            pos.current = ratio * sliderPositionEnd
        }

        // Drag & drop
        let dragMultiplier = 2.5
        let dragOrigin = 0
        let dragging = false
        let isClick = true
        let typeOfAction = "isWaiting"
        let websiteScrolling = false

        function cursorStart() {
            let $tar = $(mm.targetMouseClick)
            if ($tar.is($ssCont) || $tar.parents('.ioss--cont').is($ssCont)) {
                isClick = true
                dragging = true
                typeOfAction = "isWaiting"
                dragOrigin = pos.current
            }
        }

        function cursorMove() {
            if (dragging) {
                const dragX = Math.abs(mm.posDrag.x)
                const dragY = Math.abs(mm.posDrag.y)
                if (dragX > 20 || dragY > 20) isClick = false

                if (typeOfAction === "isWaiting") {
                    if (dragY > 20 && dragY > dragX) {
                        typeOfAction = isVertical ? 'isDragging' : 'isScrolling'
                    } else if (dragX > 20 && dragX > dragY) {
                        typeOfAction = isVertical ? 'isScrolling' : 'isDragging'
                    }
                }

                if (typeOfAction === 'isDragging') {
                    $ssCont.addClass('js-dragging')
                    $('html').addClass('js-dragging')

                    const dragAxis = isVertical ? mm.posDrag.y : mm.posDrag.x
                    pos.current = dragOrigin + dragAxis * dragMultiplier
                    pos.current = pos.current.clamp(sliderPositionStart - window.margin * 0.5, sliderPositionEnd + window.margin * 0.5)
                }
            }
        }

        function cursorEnd() {
            if (dragging) {
                $ssCont.removeClass('js-dragging')
                $('html').removeClass('js-dragging')
                pos.current = pos.current.clamp(sliderPositionStart, sliderPositionEnd)
                dragging = false
                typeOfAction = "ended"
                goToClosestSnap()
            }
        }

        function clickLink(e) {
            if (!isClick) {
                e.preventDefault()
                e.stopPropagation()
            }
        }

        function move(e) {
            if (typeOfAction === 'isDragging') e.preventDefault()
        }

        function scrollActive() { websiteScrolling = true }
        function scrollEnd() { websiteScrolling = false }


        function onScrollEvent(e) {
            if (!canMove || !canScrollWhole) return

            const delta = isVertical ? e.deltaY : e.deltaX
            const scrollAxis = isVertical ? Math.abs(e.deltaY) : Math.abs(e.deltaX)
            const otherAxis = isVertical ? Math.abs(e.deltaX) : Math.abs(e.deltaY)

            if (scrollAxis > otherAxis && scrollAxis > 0 && e.originalEvent) {
              e.originalEvent.preventDefault()
            } else if (scrollAxis > 0) {
              return
            }
            if (scrollAxis <= 0) return

            pos.current += delta * -1.5
            pos.current = pos.current.clamp(sliderPositionStart, sliderPositionEnd)

            currentId = snaps.indexOf(utils.closest(pos.current, snaps))
            isStartOrEnd()
            updateNav()
        }

        // Events
        function eventOn() {
            bus.on('pageLeaveEnd', eventOff)
            bus.on('raf', raf)
            bus.on('resize', debounceResize)
            bus.on('resizeContainer', debounceResize)
            bus.on('scroll', scrollActive)
            bus.on('scrollend', scrollEnd)
            bus.on('cursorMove', cursorMove)
            bus.on('cursorStart', cursorStart)
            bus.on('cursorEnd', cursorEnd)

            $ssCont.on('touchmove', move)
            $a.on('click', clickLink)

            scroller.on(onScrollEvent)


            $next.on('click', next)
            $prev.on('click', prev)
            $navdot.on('click', navdotClick)

            $progressbar.on('mousedown', onProgressbarMouseDown)
            bus.on('cursorMove', onProgressbarMouseMove)
            bus.on('cursorEnd', onProgressbarMouseUp)
        }

        function eventOff() {
            bus.off('pageLeaveEnd', eventOff)
            bus.off('raf', raf)
            bus.off('resize', debounceResize)
            bus.off('resizeContainer', debounceResize)
            bus.off('scroll', scrollActive)
            bus.off('scrollend', scrollEnd)
            bus.off('cursorMove', cursorMove)
            bus.off('cursorStart', cursorStart)
            bus.off('cursorEnd', cursorEnd)

            $ssCont.off('touchmove', move)
            $a.off('click', clickLink)

            scroller.off(onScrollEvent)

            $next.off('click', next)
            $prev.off('click', prev)
            $navdot.off('click', navdotClick)

            $progressbar.off('mousedown', onProgressbarMouseDown)
            bus.off('cursorMove', onProgressbarMouseMove)
            bus.off('cursorEnd', onProgressbarMouseUp)
        }

        // INIT
        eventOn()
        getSizes()
    })
}

export default ioss